import '@yandex-urbanads/sdk/carousel/styles'

import {AdvSlot} from '@yandex-urbanads/sdk/carousel'
import React from 'react'

import {classes} from './AdsBanner.classes'
import {ADS_BLOCK, ADS_CLIENT} from './model'

type AdsBannerProps = {
  isMobile: boolean
  client?: string
  block?: string
  gps?: string
}

const AdsBanner: React.FC<AdsBannerProps> = props => {
  const {isMobile, block = ADS_BLOCK, client = `${ADS_CLIENT}`, gps} = props
  return (
    <AdvSlot
      block={block}
      className={classes.AdsBanner}
      client={client}
      config={gps ? {user: {gps}} : {}}
      platform={isMobile ? 'touch' : 'desktop'}
    />
  )
}

export {AdsBanner}
